export const STATUS = [
  {
    value: 'ACTIVO',
    key: true,
  },
  {
    value: 'INACTIVO',
    key: false,
  },
];
